/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { title } from 'process';

import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { useTranslation } from 'react-i18next';

import { RadioGroup } from '../RadioGroup';
import { PatientReviewsSortOrder } from './AllPatientReviewsSortOrder';

type Props = {
  onApply: Function;
  isOpen: boolean;
  setIsOpen: (a: boolean) => void;
  sortOrder: string;
  setSortOrder: Function;
};

export const AllPatientReviewsSortMobile = ({
  onApply,
  sortOrder,
  isOpen,
  setIsOpen,
  setSortOrder,
}: Props) => {
  const { t } = useTranslation();

  const properties = {
    drawerSize: 'fit-content',
    drawerPosition: 'right',
  };

  const handleOnApply = (value: string) => {
    if (value) {
      onApply(value);
    }
    setIsOpen(false);
    setSortOrder(value);
  };

  return (
    <Flex>
      {isOpen ? (
        <Drawer
          css={{
            'abyss-modal-base-content-container': {
              borderRadius: '20px 20px 0px 0px',
              padding: '$md',
              height: 'auto !important',
              '.abyss-radio-root': {
                '&:hover': {
                  backgroundColor: '$core.color.aqua.15',
                },
              },
            },
            'abyss-modal-close-button': {
              top: '12px',
              right: '12px',
            },
            'abyss-modal-header-container': {
              padding: '0',
              marginBottom: '$md',
            },
            'abyss-modal-content-title': {
              fontFamily: '$primary !important',
              fontSize: 'medium !important',
              fontWeight: 'bold !important',
              lineHeight: '24px !important',
              color: '$core.color.neutral.80 !important',
              padding: '0',
            },
          }}
          header={t('SORT_BUTTONS.SORT_REVIEWS')}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          position="right"
          size={properties.drawerSize}
        >
          <RadioGroup
            defaultValue={sortOrder}
            labelFontSize="18px"
            locationForAnalytics={`modal:${title}`}
            model="SortBy"
            onApply={handleOnApply}
            options={[
              {
                label: t(PatientReviewsSortOrder.MOST_RECENT),
                value: PatientReviewsSortOrder.MOST_RECENT,
              },
              {
                label: t(PatientReviewsSortOrder.HIGHEST_RATING),
                value: PatientReviewsSortOrder.HIGHEST_RATING,
              },
              {
                label: t(PatientReviewsSortOrder.LOWEST_RATING),
                value: PatientReviewsSortOrder.LOWEST_RATING,
              },
            ]}
            submitBtnName={t('Sort')}
          />
        </Drawer>
      ) : null}
    </Flex>
  );
};
